import { useEffect } from 'react';
export function useOutsideClick(container, handleClick) {
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (event.target instanceof HTMLElement && container.current && !container.current.contains(event.target)) {
                handleClick();
            }
        };
        window.addEventListener('mousedown', handleClickOutside);
        return function () {
            window.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClick]);
}
//# sourceMappingURL=useOutsideClick.js.map